module.exports = __webpack_public_path__ + "static/media/weddingPlannerFront1.12df7423.png";